interface HighlightProps {
  text: string;
  keyword: string;
}

export default function Highlight({ text, keyword }: HighlightProps) {
  const kw = keyword.trim();
  if (!kw) return <>{text}</>;

  const lowerText = text.toLowerCase();
  const lowerKw = kw.toLowerCase();
  const index = lowerText.indexOf(lowerKw);

  if (index === -1) return <>{text}</>;

  return (
    <>
      {text.slice(0, index)}
      <mark className="bg-accent-200 text-accent-950 rounded px-0.5">
        {text.slice(index, index + kw.length)}
      </mark>
      {text.slice(index + kw.length)}
    </>
  );
}